module.exports = __webpack_public_path__ + "img/DisplayX1960.d5841f71.svg";